// src/pages/atributos/EditarTipoAtributo.js
import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

function EditarTipoAtributo({ mostrar, tipo, guardar, cancelar }) {
	const [nombre, setNombre] = useState('')
	const [descripcion, setDescripcion] = useState('')
	const [activo, setActivo] = useState(true)
	const [errores, setErrores] = useState({})
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (tipo && mostrar) {
			setNombre(tipo.nombre || '')
			setDescripcion(tipo.descripcion || '')
			setActivo(tipo.activo)
		}
	}, [tipo, mostrar])

	const handleClose = () => {
		setErrores({})
		cancelar()
	}

	const validar = () => {
		const nuevosErrores = {}

		if (!nombre.trim()) {
			nuevosErrores.nombre = 'El nombre es obligatorio'
		}

		setErrores(nuevosErrores)
		return Object.keys(nuevosErrores).length === 0
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (!validar()) return

		setLoading(true)

		try {
			await guardar({
				nombre: nombre.trim(),
				descripcion: descripcion.trim() || null,
				activo
			})
		} catch (error) {
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	if (!tipo) return null

	return (
		<Modal show={mostrar} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>
					<i className="fa fa-pencil text-primary me-2"></i>
					Editar tipo de atributo
				</Modal.Title>
			</Modal.Header>
			<Form onSubmit={handleSubmit}>
				<Modal.Body>
					<Form.Group className="mb-3" controlId="nombre">
						<Form.Label>Nombre *</Form.Label>
						<Form.Control
							type="text"
							value={nombre}
							onChange={(e) => setNombre(e.target.value)}
							placeholder="Ej: Talla Bebé, Color, Material..."
							isInvalid={!!errores.nombre}
							autoFocus
						/>
						<Form.Control.Feedback type="invalid">
							{errores.nombre}
						</Form.Control.Feedback>
					</Form.Group>

					<Form.Group className="mb-3" controlId="descripcion">
						<Form.Label>Descripción</Form.Label>
						<Form.Control
							as="textarea"
							rows={2}
							value={descripcion}
							onChange={(e) => setDescripcion(e.target.value)}
							placeholder="Descripción opcional del tipo de atributo..."
						/>
					</Form.Group>

					<Form.Group className="mb-3" controlId="activo">
						<Form.Check
							type="switch"
							label="Activo"
							checked={activo}
							onChange={(e) => setActivo(e.target.checked)}
						/>
						<Form.Text className="text-muted">
							Solo los tipos activos estarán disponibles para asignar a categorías y productos
						</Form.Text>
					</Form.Group>

					<div className="bg-light rounded p-3">
						<small className="text-muted">
							<i className="fa fa-info-circle me-1"></i>
							Este tipo tiene <strong>{tipo.valores?.length || 0}</strong> valores configurados.
							Los valores se gestionan desde la lista principal.
						</small>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
						Cancelar
					</Button>
					<Button variant="primary" type="submit" disabled={loading}>
						{loading ? (
							<>
								<i className="fa fa-spinner fa-spin me-2"></i>
								Guardando...
							</>
						) : (
							<>
								<i className="fa fa-save me-2"></i>
								Guardar cambios
							</>
						)}
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	)
}

export default EditarTipoAtributo